import React from 'react';
import { Icon } from 'ui';
import InfoTooltip from 'components/shared/InfoTooltip';

class WebsiteURL extends React.Component {
  constructor(props) {
    super(props);
    this.handleInput = this.handleInput.bind(this);
  }

  handleInput(e) {
    this.props.handleWebsiteURLInput(e.target.name, e.target.value);
  }

  pageSelectorMetadata(value, label) {
    return (
      <div>
        <div className="HelpText HelpText--muted HelpText--noTopMargin">
          <span>
            {label}: {value}
          </span>
        </div>
      </div>
    );
  }

  render() {
    const {
      editing,
      relatedUrl,
      param,
      i18n,
      errorMessage,
      types,
      deleteURL,
      editRelatedUrl,
      canUseOnPageContext,
    } = this.props;

    if (editing) {
      return (
        <div className="FlexboxTable-cell RelatedUrlsTable-leftCell">
          <div>
            <input
              name={param}
              className="NewInput NewInput--white NewInput--fw"
              onChange={this.handleInput}
              value={relatedUrl[param] || ''}
              placeholder={i18n.new_url}
              type="text"
            />
            {types.length > 1 && (
              <div className="mt-12 mb-8 HelpText HelpText--muted">
                {i18n.show_on}
              </div>
            )}
            <select
              name="matchType"
              value={relatedUrl.matchType}
              onChange={this.handleInput}
              id="matchTypeSelect"
              hidden={types.length === 1}
            >
              {types.map(type => (
                <option value={type.type} key={type.type}>
                  {type.title}
                </option>
              ))}
            </select>
            {canUseOnPageContext && (
              <div className="mt-32">
                <div className="mt-8 mb-8 HelpText HelpText--muted">
                  {i18n.page_content_selector.css_selector.input_label}
                  <InfoTooltip
                    tooltip={
                      i18n.page_content_selector.css_selector.input_tooltip
                    }
                    className="ml-4 wb-n"
                  />
                </div>
                <input
                  name="pageContentSelector"
                  className="NewInput NewInput--white NewInput--fw"
                  onChange={this.handleInput}
                  value={relatedUrl.pageContentSelector || ''}
                  type="text"
                />
                <div className="mt-12 mb-8 HelpText HelpText--muted">
                  {i18n.page_content_selector.css_selector_text.input_label}
                  <InfoTooltip
                    tooltip={
                      i18n.page_content_selector.css_selector_text.input_tooltip
                    }
                    className="ml-4 wb-n"
                  />
                </div>
                <input
                  name="pageContentText"
                  className="NewInput NewInput--white NewInput--fw"
                  onChange={this.handleInput}
                  value={relatedUrl.pageContentText || ''}
                  type="text"
                />
                {!relatedUrl.pageContentSelector &&
                  relatedUrl.pageContentText && (
                    <div className="mt-4 c-brand-red">
                      {
                        i18n.page_content_selector.css_selector_text
                          .missing_selector_warning
                      }
                    </div>
                  )}
              </div>
            )}
            {errorMessage && (
              <div className="mt-4 c-brand-red ws-pr">{errorMessage}</div>
            )}
          </div>
        </div>
      );
    }

    return (
      <div className="FlexboxTable-cell RelatedUrlsTable-leftCell">
        <div className="d-f jc-sb">
          <div className="ha mr-12">
            {relatedUrl[param]}
            {param === 'url' && (
              <div>
                {relatedUrl.matchType === 'exact' && (
                  <div className="HelpText HelpText--muted HelpText--noTopMargin">
                    <Icon name="link-mirrored" />{' '}
                    {i18n.existing_mapping_URLonly}
                  </div>
                )}
                {relatedUrl.matchType === 'prefix' && (
                  <div className="HelpText HelpText--muted HelpText--noTopMargin">
                    <Icon name="tree" /> {i18n.existing_mapping_subpages}
                  </div>
                )}
              </div>
            )}
            {relatedUrl.pageContentSelector &&
              this.pageSelectorMetadata(
                relatedUrl.pageContentSelector,
                i18n.page_content_selector.css_selector.name,
              )}
            {relatedUrl.pageContentText &&
              this.pageSelectorMetadata(
                relatedUrl.pageContentText,
                i18n.page_content_selector.css_selector_text.name,
              )}
          </div>
          <div className="ha IndexAction-container">
            <button
              type="button"
              className="ButtonWithTooltip IndexAction-button IndexAction-button--square"
              data-tooltip={i18n.edit_tooltip}
              onClick={editRelatedUrl}
              onKeyDown={e => e.key === 'Enter' && editRelatedUrl()}
            >
              <Icon name="edit" />
            </button>
            <button
              type="button"
              className="ButtonWithTooltip IndexAction-button IndexAction-button--square"
              data-tooltip={i18n.delete_tooltip}
              onClick={deleteURL}
              onKeyDown={e => e.key === 'Enter' && deleteURL()}
            >
              <Icon name="delete" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default WebsiteURL;
